module.exports = {
  '1': { idx: '487', name: 'Pfirsich', value: 'rgb(246, 164, 126)' },
  '2': { idx: '023', name: 'Koralle', value: 'rgb(247, 181, 153)' },
  '3': { idx: '945', name: 'Drachenfrucht', value: 'rgb(159, 24, 71)' },
  '4': { idx: '221', name: 'Himbeere', value: 'rgb(139, 27, 65)' },
  '5': { idx: '136', name: 'Weinrot', value: 'rgb(79, 34, 41)' },
  '6': { idx: '209', name: 'Bordeaux', value: 'rgb(84, 34, 47)' },
  '7': { idx: '102', name: 'Kirsche', value: 'rgb(105, 28, 29)' },
  '8': { idx: '201', name: 'Rot', value: 'rgb(120, 29, 31)' },
  '9': { idx: '125', name: 'Tomate', value: 'rgb(160, 32, 25)' },
  '10': { idx: '179', name: 'Hellrot', value: 'rgb(189, 31, 27)' },
  '11': { idx: '180', name: 'Terracotta', value: 'rgb(155, 58, 48)' },
  '12': { idx: '173', name: 'Mango', value: 'rgb(187, 58, 49)' },
  '13': { idx: '105', name: 'Rost', value: 'rgb(161, 61, 16)' },
  '14': { idx: '573', name: 'Kupfer', value: 'rgb(162, 96, 52)' },
  '15': { idx: '116', name: 'Orange', value: 'rgb(197, 110, 0)' },
  '16': { idx: '495', name: 'Abricot', value: 'rgb(243, 127, 0)' },
  '17': { idx: '124', name: 'Gelb', value: 'rgb(255, 180, 0)' },
  '18': { idx: '131', name: 'Honig', value: 'rgb(243, 184, 83)' },
  '19': { idx: '509', name: 'Kamel', value: 'rgb(223, 163, 39)' },
  '20': { idx: '550', name: 'Ocker', value: 'rgb(182, 135, 1)' },
  '21': { idx: '274', name: 'Senf', value: 'rgb(195, 159, 0)' },
  '22': { idx: '108', name: 'Zitrone', value: 'rgb(255, 229, 35)' },
  '23': { idx: '403', name: 'Mais', value: 'rgb(255, 239, 130)' },
  '24': { idx: '535', name: 'Sesam', value: 'rgb(231, 225, 170)' },
  '25': { idx: '203', name: 'Vanille', value: 'rgb(221, 214, 135)' },
  '26': { idx: '027', name: 'Kartause', value: 'rgb(206, 201, 101)' },
  '27': { idx: '384', name: 'Lind', value: 'rgb(151, 161, 68)' },
  '28': { idx: '713', name: 'Kiwi', value: 'rgb(155, 172, 78)' },
  '29': { idx: '377', name: 'Maigrün', value: 'rgb(117, 168, 46)' },
  '30': { idx: '732', name: 'Farn', value: 'rgb(82, 101, 32)' },
  '31': { idx: '378', name: 'Oliv', value: 'rgb(75, 100, 33)' },
  '32': { idx: '260', name: 'Sprießen', value: 'rgb(165, 201, 158)' },
  '34': { idx: '343', name: 'D’Grün', value: 'rgb(23, 54, 31)' },
  '35': { idx: '435', name: 'Smaragd', value: 'rgb(44, 89, 71)' },
  '36': { idx: '625', name: 'Pinie', value: 'rgb(59, 124, 114)' },
  '37': { idx: '248', name: 'Jade', value: 'rgb(101, 180, 145)' },
  '38': { idx: '472', name: 'Minze', value: 'rgb(95, 178, 163)' },
  '39': { idx: '575', name: 'Salbei', value: 'rgb(165, 207, 189)' },
  '40': { idx: '483', name: 'Adria', value: 'rgb(95, 140, 152)' },
  '41': { idx: '548', name: 'Türkis', value: 'rgb(10, 148, 157)' },
  '42': { idx: '312', name: 'Lagune', value: 'rgb(51, 144, 153)' },
  '43': { idx: '345', name: 'Pazifik', value: 'rgb(0, 101, 106)' },
  '44': { idx: '308', name: 'Petrol', value: 'rgb(0, 93, 127)' },
  '45': { idx: '698', name: 'Dunst', value: 'rgb(64, 115, 145)' },
  '46': { idx: '405', name: 'Stahl', value: 'rgb(70, 115, 140)' },
  '47': { idx: '215', name: 'Meer', value: 'rgb(42, 86, 100)' },
  '48': { idx: '540', name: 'Ozean', value: 'rgb(5, 66, 103)' },
  '49': { idx: '533', name: 'Indigo', value: 'rgb(39, 60, 85)' },
  '50': { idx: '282', name: 'D’Blau', value: 'rgb(20, 38, 71)' },
  '51': { idx: '111', name: 'Traube', value: 'rgb(23, 62, 101)' },
  '52': { idx: '626', name: 'Azur', value: 'rgb(0, 52, 113)' },
  '53': { idx: '647', name: 'Kobalt', value: 'rgb(6, 73, 114)' },
  '54': { idx: '686', name: 'Enzian', value: 'rgb(13, 98, 153)' },
  '55': { idx: '272', name: 'Royal', value: 'rgb(19, 71, 167)' },
  '56': { idx: '286', name: 'H’Blau', value: 'rgb(17, 100, 192)' },
  '57': { idx: '995', name: 'Wasser', value: 'rgb(67, 175, 232)' },
  '58': { idx: '458', name: 'Bewölkt', value: 'rgb(125, 209, 230)' },
  '59': { idx: '284', name: 'Himmel', value: 'rgb(107, 176, 233)' },
  '60': { idx: '613', name: 'Gletscher', value: 'rgb(126, 169, 195)' },
  '61': { idx: '551', name: 'Eis', value: 'rgb(180, 226, 242)' },
  '62': { idx: '113', name: 'Immergrün', value: 'rgb(155, 185, 232)' },
  '63': { idx: '099', name: 'Lila', value: 'rgb(150, 158, 215)' },
  '64': { idx: '667', name: 'Amethyst', value: 'rgb(103, 98, 144)' },
  '65': { idx: '242', name: 'Pink', value: 'rgb(131, 27, 108)' },
  '66': { idx: '640', name: 'Granat', value: 'rgb(128, 51, 79)' },
  '67': { idx: '634', name: 'Erröten', value: 'rgb(205, 131, 171)' },
  '68': { idx: '671', name: 'Pfingstrose', value: 'rgb(231, 171, 195)' },
  '69': { idx: '255', name: 'Flieder', value: 'rgb(97, 48, 113)' },
  '70': { idx: '269', name: 'Violett', value: 'rgb(57, 45, 122)' },
  '71': { idx: '437', name: 'Aubergine', value: 'rgb(49, 32, 50)' },
  '72': { idx: '250', name: 'Trüffelbraun', value: 'rgb(47, 44, 40)' },
  '73': { idx: '220', name: 'Rehbraun', value: 'rgb(81, 72, 60)' },
  '74': { idx: '411', name: 'Alpaka', value: 'rgb(76, 73, 70)' },
  '75': { idx: '190', name: 'Natur-meliert', value: 'rgb(95, 93, 86)' },
  '76': { idx: '200', name: 'Natur', value: 'rgb(106, 99, 93)' },
  '77': { idx: '331', name: 'Sahara', value: 'rgb(169, 159, 127)' },
  '78': { idx: '311', name: 'Mandel', value: 'rgb(213, 185, 149)' },
  '79': { idx: '467', name: 'Sand', value: 'rgb(195, 177, 138)' },
  '80': { idx: '481', name: 'Sandstein', value: 'rgb(221, 204, 179)' },
  '81': { idx: '100', name: 'Wollweiß', value: 'rgb(255, 255, 236)' },
  '82': { idx: '110', name: 'Rohweiß', value: 'rgb(249, 238, 196)' },
  '83': { idx: '160', name: 'Beige', value: 'rgb(195, 189, 167)' },
  '84': { idx: '529', name: 'Champagner', value: 'rgb(196, 191, 171)' },
  '85': { idx: '150', name: 'Weiß', value: 'rgb(209, 211, 200)' },
  '86': { idx: '428', name: 'Silber', value: 'rgb(208, 221, 221)' },
  '87': { idx: '427', name: 'Stein', value: 'rgb(194, 200, 195)' },
  '88': { idx: '021', name: 'Beton', value: 'rgb(199, 208, 214)' },
  '89': { idx: '170', name: 'Asche', value: 'rgb(149, 156, 154)' },
  '90': { idx: '423', name: 'Hellgrau', value: 'rgb(140, 151, 151)' },
  '91': { idx: '408', name: 'Taupe', value: 'rgb(135, 134, 125)' },
  '92': { idx: '175', name: 'Graphit', value: 'rgb(78, 87, 90)' },
  '93': { idx: '425', name: 'Taubengrau', value: 'rgb(88, 102, 101)' },
  '94': { idx: '446', name: 'Kohle', value: 'rgb(39, 60, 63)' },
  '95': { idx: '300', name: 'Anthrazit', value: 'rgb(44, 52, 53)' },
  '96': { idx: '426', name: 'Schwarz', value: 'rgb(27, 33, 30)' },
};


// WEBPACK FOOTER //
// ./src/universal/filzfelt/colors.js